import ReactDOM from "react-dom";
import { Box, Typography, Button, Modal } from "@mui/material";

export default function ConfirmModel(props) {
  const { isOpen, title, description, confirmText = "Confirm", cancelText = "Cancel", onConfirm, onCancel, onClose } = props;

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <>
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="deleteModal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {title}
          </Typography>
          <Typography id="modal-modal-title">
            {description}
          </Typography>
          <Box className="buttons-div">
            <Button variant="outlined" onClick={onCancel}>
              {cancelText}
            </Button>
            <Button
              variant="outlined"
              onClick={onConfirm}
            >
              {confirmText}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>,
    document.body
  );
};
